<template>
  <div class="out_wrap">
    <el-container>
      <el-main>
        <div class="headBtn-group">
          <el-button @click="addInspecTask">
            <el-image src="https://kc-res.izsw.net/apps/qrobot-inspection-system/addBtnIcon.png" fit="contain"></el-image>
            <span>新增巡检任务</span>
          </el-button>
        </div>
        <el-table :data="tableData" stripe v-loading="loading">
          <el-table-column label="编号" align="center" min-width="60px">
            <template slot-scope="{ $index }">
              {{ $index + 1 + (searchParam.page - 1) * searchParam.pageSize }}
            </template>
          </el-table-column>
          <el-table-column label="任务名称" show-overflow-tooltip align="center" prop="name" min-width="180px">
          </el-table-column>
          <el-table-column label="巡检开始时间" show-overflow-tooltip align="center" prop="startDate" min-width="160px">
            <template slot-scope="{ row }">
              <div class="period">
                <el-image fit="contain" :src="row.task_type === 1
                    ? 'https://kc-res.izsw.net/apps/qrobot-inspection-system/dayPeriodIcon.png'
                    : 'https://kc-res.izsw.net/apps/qrobot-inspection-system/weekPeriodIcon.png'
                  "></el-image>
              </div>
              <span class="startDate">{{ row.published_at | dateFilter }}
                {{ row.start_time | timeFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="220px" align="center">
            <template slot-scope="scope">
              <div class="operateBtn-group">
                <el-button class="inspMap" @click="inspMap(scope.row)">巡检地图</el-button>
                <el-button class="editBtn" @click="editInsp(scope.row)">编辑</el-button>
                <el-button class="delBtn" @click="delInsp(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="paginationInfo.total" background :page-size.sync="searchParam.pageSize"
          :current-page.sync="searchParam.page" layout="prev, pager, next,slot" :pager-count="11"
          :total="paginationInfo.total" @current-change="getPages">
          <span class="slot">{{
            "共" + paginationInfo.lastPage + "页," + paginationInfo.total + "条"
          }}</span>
        </el-pagination>
      </el-main>
      <footNav :active="activeNav"></footNav>
    </el-container>
    <!-- 新增巡检任务弹框 -->
    <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" :visible.sync="addInspectionVisible" :class="[
      'addInspectionDialog',
      addInspInfo.task_type === 2 ? 'addInspectionWeek' : 'addInspectionDay'
    ]" width="450px" center title="新增巡检任务" @closed="closeAddInspectionDialog">
      <div class="dialog_content">
        <el-form :model="addInspInfo" :rules="addInspInfoRules" ref="addInspInfoForm" label-position="top"
          label-width="100px">
          <el-form-item label="任务名称" prop="name">
            <el-input v-model="addInspInfo.name" placeholder="请输入任务名称"></el-input>
          </el-form-item>
          <el-form-item label="巡检周期" prop="task_type">
            <el-select v-model="addInspInfo.task_type" placeholder="请选择周期" @change="periodChange('add')">
              <el-option label="以天为周期" :value="1"></el-option>
              <el-option label="以周为周期" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="巡检周期" prop="week_days" v-if="addInspInfo.task_type === 2">
            <el-select v-model="addInspInfo.week_days" multiple placeholder="请选择周几" clearable>
              <el-option label="周一" :value="1"></el-option>
              <el-option label="周二" :value="2"></el-option>
              <el-option label="周三" :value="3"></el-option>
              <el-option label="周四" :value="4"></el-option>
              <el-option label="周五" :value="5"></el-option>
              <el-option label="周六" :value="6"></el-option>
              <el-option label="周日" :value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="巡检开始时间" prop="start_time">
            <el-time-picker value-format="HH:mm" format="HH:mm" v-model="addInspInfo.start_time" placeholder="选择巡检开始时间">
            </el-time-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="submit" @click="submitAddInsp" :disabled="canBtnClick ? false : true">确定</el-button>
        <el-button class="cancel" @click="cancelAddInsp">取消</el-button>
      </span>
    </el-dialog>
    <!-- 巡检地图弹框 -->
    <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" :visible.sync="inspectionMapVisible"
      class="inspectionMapDialog" width="1225px" center>
      <div class="dialog_content">
        <el-image :src="inspMapInfo.img" fit="contain"></el-image>
      </div>
    </el-dialog>
    <!-- 编辑巡检任务弹框 -->
    <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" :visible.sync="editInspectionVisible" :class="[
      'editInspectionDialog',
      editInspInfo.task_type === 2
        ? 'editInspectionWeek'
        : 'editInspectionDay'
    ]" width="450px" center title="编辑巡检任务" @closed="closeEditInspectionDialog">
      <div class="dialog_content">
        <el-form :model="editInspInfo" :rules="editInspInfoRules" ref="editInspInfoForm" label-position="top"
          label-width="100px">
          <el-form-item label="任务名称" prop="name">
            <el-input v-model="editInspInfo.name" placeholder="请输入任务名称"></el-input>
          </el-form-item>
          <el-form-item label="巡检周期" prop="task_type">
            <el-select v-model="editInspInfo.task_type" placeholder="请选择周期" @change="periodChange('edit')">
              <el-option label="以天为周期" :value="1"></el-option>
              <el-option label="以周为周期" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="巡检周期" prop="week_days" v-if="editInspInfo.task_type === 2">
            <el-select v-model="editInspInfo.week_days" multiple placeholder="请选择周几" clearable>
              <el-option label="周一" :value="1"></el-option>
              <el-option label="周二" :value="2"></el-option>
              <el-option label="周三" :value="3"></el-option>
              <el-option label="周四" :value="4"></el-option>
              <el-option label="周五" :value="5"></el-option>
              <el-option label="周六" :value="6"></el-option>
              <el-option label="周日" :value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="巡检开始时间" prop="start_time">
            <el-time-picker value-format="HH:mm" format="HH:mm" v-model="editInspInfo.start_time" placeholder="选择巡检开始时间">
            </el-time-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="submit" @click="submitEditInsp" :disabled="canBtnClick ? false : true">确定</el-button>
        <el-button class="cancel" @click="cancelEditInsp">取消</el-button>
      </span>
    </el-dialog>
    <!-- 删除巡检任务弹框 -->
    <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" :visible.sync="delInspectionVisible"
      class="delInspectionDialog" width="450px" center title="系统提示">
      <div class="dialog_content">
        <p>删除后无法恢复，是否确认删除当前任务</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="submit" @click="submitDelInsp" :disabled="canBtnClick ? false : true">确定</el-button>
        <el-button class="cancel" @click="cancelDelInsp">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import footNav from "@/components/footNav";
import {
  taskList,
  addTask,
  editTask,
  delTask
} from "@/assets/api/InspectionTaskMG";
export default {
  name: "InspectionTask",
  components: {
    footNav
  },
  data() {
    return {
      activeNav: "1", // 当前选中nav
      tableData: [], // 表格数据
      loading: true, // 表格数据loading显隐
      // 搜索信息
      searchParam: {
        page: 1, // 当前页数
        pageSize: this.$store.state.limit // 每页条数
      },
      // 分页器信息
      paginationInfo: {
        total: 0, // 总条数
        lastPage: 0 // 总页数
      },
      canBtnClick: true, // 弹框按钮是否可点
      // 新增巡检任务弹框信息
      addInspInfo: {
        name: "",
        task_type: null,
        week_days: [],
        start_time: ""
      },
      addInspectionVisible: false, // 新增巡检任务弹框显隐
      // 新增巡检任务校验信息
      addInspInfoRules: {
        name: [
          {
            required: true,
            message: "请输入任务名称",
            trigger: "blur"
          }
        ],
        task_type: [
          {
            required: true,
            message: "请选择巡检周期",
            trigger: "change"
          }
        ],
        week_days: [
          {
            required: true,
            message: "请选择周几巡检",
            trigger: "change"
          }
        ],
        start_time: [
          {
            required: true,
            message: "请选择巡检开始时间",
            trigger: "change"
          }
        ]
      },
      inspectionMapVisible: false, // 巡检地图弹框显隐
      inspMapInfo: {}, // 巡检地图弹框信息
      // 编辑巡检任务弹框信息
      editInspInfo: {
        uuid: "",
        name: "",
        task_type: null,
        week_days: [],
        start_time: ""
      },
      editInspectionVisible: false, // 编辑巡检任务弹框显隐
      // 编辑巡检任务校验信息
      editInspInfoRules: {
        name: [
          {
            required: true,
            message: "请输入任务名称",
            trigger: "blur"
          }
        ],
        task_type: [
          {
            required: true,
            message: "请选择巡检周期",
            trigger: "change"
          }
        ],
        week_days: [
          {
            required: true,
            message: "请选择周几巡检",
            trigger: "change"
          }
        ],
        start_time: [
          {
            required: true,
            message: "请选择巡检开始时间",
            trigger: "change"
          }
        ]
      },
      // 删除巡检任务弹框信息
      delInspInfo: {},
      delInspectionVisible: false // 删除巡检任务弹框显隐
    };
  },
  filters: {
    dateFilter(value) {
      if (value) {
        return value.substring(0, 10).replace(/-/g, "/");
      }
    },
    timeFilter(value) {
      if (value) {
        return value.substring(0, 5);
      }
    }
  },
  watch: {
    $route(to, from) {
      this.$route.query.page &&
        (this.searchParam.page = this.$route.query.page * 1);
      this.getTableData();
    }
  },
  created() {
    this.$route.query.page &&
      (this.searchParam.page = this.$route.query.page * 1);
    this.getTableData();
  },
  methods: {
    // 获取巡检任务列表数据
    getTableData() {
      this.loading = true;
      taskList(this.searchParam).then(res => {
        if (!res.data.length && res.current_page > 1) {
          this.searchParam.page--;
          this.$router.replace(
            {
              name: "InspectionTask",
              query: {
                page: this.searchParam.page
              }
            },
            () => { }
          );
          return;
        }
        this.tableData = res.data.data;
        this.paginationInfo.total = res.data.total;
        this.paginationInfo.lastPage = res.data.last_page;
        this.loading = false;
      });
    },
    // 打开新建巡检任务弹框
    addInspecTask() {
      this.addInspectionVisible = true;
    },
    // 页数切换
    getPages(val) {
      this.tableData = [];
      this.$router.replace(
        {
          name: "InspectionTask",
          query: {
            page: val
          }
        },
        () => { }
      );
    },
    // 周期切换
    periodChange(val) {
      if (val === "add") {
        this.addInspInfo.week_days = [];
      } else {
        this.editInspInfo.week_days = [];
      }
    },
    // 提交新增巡检任务
    submitAddInsp() {
      this.$refs["addInspInfoForm"].validate(valid => {
        if (valid) {
          this.canBtnClick = false;
          addTask(this.addInspInfo).then(res => {
            this.addInspectionVisible = false;
            this.getTableData();
            this.canBtnClick = true;
            this.$refs["addInspInfoForm"].resetFields();
          });
        } else {
          return false;
        }
      });
    },
    // 取消新增巡检任务
    cancelAddInsp() {
      this.$refs["addInspInfoForm"].resetFields();
      this.$refs["addInspInfoForm"].clearValidate();
      this.addInspectionVisible = false;
    },
    // 关闭新增巡检任务弹框
    closeAddInspectionDialog() {
      this.$refs["addInspInfoForm"].clearValidate();
    },
    // 巡检地图
    inspMap(row) {
      // this.inspMapInfo = row;
      this.inspMapInfo = {
        img: "https://kc-res.izsw.net/apps/qrobot-inspection-system/map1.png"
      };
      this.inspectionMapVisible = true;
    },
    // 打开编辑巡检任务弹框
    editInsp(row) {
      this.editInspInfo = JSON.parse(JSON.stringify(row));
      this.editInspectionVisible = true;
    },
    // 提交编辑巡检任务
    submitEditInsp() {
      this.$refs["editInspInfoForm"].validate(valid => {
        if (valid) {
          this.canBtnClick = false;
          editTask(this.editInspInfo).then(res => {
            this.editInspectionVisible = false;
            this.getTableData();
            this.canBtnClick = true;
            this.$refs["editInspInfoForm"].resetFields();
          });
        } else {
          return false;
        }
      });
    },
    // 取消编辑巡检任务
    cancelEditInsp() {
      this.editInspectionVisible = false;
      this.editInspInfo = {
        uuid: "",
        name: "",
        task_type: null,
        week_days: [],
        start_time: ""
      };
      this.$refs["editInspInfoForm"].clearValidate();
    },
    // 关闭编辑巡检任务
    closeEditInspectionDialog() {
      this.$refs["editInspInfoForm"].clearValidate();
      this.editInspInfo = {
        uuid: "",
        name: "",
        task_type: null,
        week_days: [],
        start_time: ""
      };
      this.editInspectionVisible = false;
    },
    // 打开删除巡检任务弹框
    delInsp(row) {
      this.delInspInfo = row;
      this.delInspectionVisible = true;
    },
    // 提交删除巡检任务
    submitDelInsp() {
      this.canBtnClick = false;
      delTask({ uuid: this.delInspInfo.uuid }).then(res => {
        this.delInspectionVisible = false;
        this.getTableData();
        this.canBtnClick = true;
      });
    },
    // 取消删除巡检任务
    cancelDelInsp() {
      this.delInspectionVisible = false;
    }
  }
};
</script>
<style scoped lang="scss">
.out_wrap {
  .el-container {
    .el-main {
      & /deep/.el-table {
        .el-table__cell .cell {
          display: flex;
          align-items: center;
          justify-content: center;

          .period {
            width: 25px;
            height: 25px;
            margin-right: 10px;
          }

          .startDate {
            display: inline-block;
            width: 128px;
          }
        }
      }
    }
  }

  /deep/ .addInspectionDialog,
  /deep/ .editInspectionDialog {
    .el-dialog__body {
      padding: 12px 34px 0;

      .dialog_content {
        .el-form {
          .el-form-item {
            .el-form-item__label {
              font-size: 16px;
              color: #ffffff;
              line-height: 1;
            }

            .el-form-item__content {

              .el-select,
              .el-date-editor {
                width: 100%;
              }

              .el-date-editor {
                .el-input__prefix i {
                  color: #ffffff;
                }
              }

              .el-select__tags {
                max-width: 300px !important;

                span.el-tag {
                  background: none;
                  border: none;
                  color: #ffffff;
                  padding-right: 0px;

                  i {
                    color: #ffffff;
                    background: none;
                    border-radius: 0;
                    right: 0px;

                    &::before {
                      content: "、";
                    }
                  }

                  &:nth-child(n + 2) {
                    margin-left: 0;
                    padding-left: 0;
                  }
                }
              }

              .el-input__inner {
                line-height: 40px;
                min-height: 40px;
                background: #4b6db3;
                border: 1px solid #89a8f9;
                font-size: $text-smallTitle;
                color: #ffffff;

                &::placeholder {
                  color: #d2e8f7;
                }
              }
            }
          }
        }
      }
    }
  }

  .addInspectionDay /deep/.el-dialog,
  .editInspectionDay /deep/.el-dialog {
    height: 439px;
    background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/dialogBg437.png") no-repeat center center/100% 100%;
  }

  .addInspectionWeek /deep/.el-dialog,
  .editInspectionWeek /deep/.el-dialog {
    height: 525px;
    background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/dialogBg525.png") no-repeat center center/100% 100%;
  }

  .inspectionMapDialog /deep/.el-dialog {
    height: 730px;
    background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/dialogBg730.png") no-repeat center center/100% 100%;

    .el-dialog__header {
      height: 100px;
    }

    .el-dialog__body {
      padding: 0 65px 25px;

      .dialog_content {
        .el-image {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .delInspectionDialog /deep/.el-dialog {
    height: 289px;
    background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/dialogBg289.png") no-repeat center center/100% 100%;

    .el-dialog__body {
      height: 133px;

      .dialog_content {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        p {
          font-size: $text-smallTitle;
          color: #ffffff;
          line-height: 1.4;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/InspectionTask.vue